import React, { useEffect } from 'react';
import { useTranslation, useToast } from '@repo/core';
import { useSearchParams } from 'react-router-dom';
import SubscriptionUpgradePanel from '../../components/ui/SubscriptionUpgradePanel';

const Subscriptions: React.FC = () => {
    const { t } = useTranslation();
    const { addSuccessMessage, addInfoMessage } = useToast();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        if (searchParams.get('success')) {
            addSuccessMessage(t('subscriptions.checkoutSuccess'));
        } else if (searchParams.get('canceled')) {
            addInfoMessage(t('subscriptions.checkoutCanceled'));
        }
    }, [searchParams, addSuccessMessage, addInfoMessage, t]);

    // Same content as the toolbar's subscription-renewal dialog.
    return (
        <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center p-4">
            <SubscriptionUpgradePanel />
        </div>
    );
};

export default Subscriptions;
